import React from "react";
import { Row, Col, Button, Input, Drawer, DatePicker, Select, Form } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import TextArea from "antd/lib/input/TextArea";
import Close from "../../../../assets/images/close-x.svg";
import Offer from "../../../../assets/images/promoTag.svg";
import CancelArrow from "../../../../assets/images/cancelArrow.svg";
import BarCodeComponentForExternalCoupon from "../../../../lib/BarCodeComponentForExternalCoupon";

const CouponDrawer = ({
  couponModalVisible,
  closeCouponModal,
  additionalInfo,
  setAdditionalInfo,
  additionalInfoForm,
  couponInfo,
  externalCoupons,
  selectedCoupon,
  setSelectedCoupon,
  selectedExternalCouponType,
  setSelectedExternalCouponType,
  couponInputRef,
  couponInput,
  setCouponInput,
  setIsInputFocused,
  manualDiscountInput,
  setManualDiscountInput,
  handleCouponInput,
  checkCoupon,
  couponValidating,
  checkExternalCoupon,
  tillData,
  totalBillDiscountData,
  cart,
  width,
  removeCouponConfirmation,
  searchInputRef,
}) => {
  return (
    <Drawer
      placement="bottom"
      closable={false}
      title={
        <div style={{ display: "flex", alignItems: "center", fontSize: "1vw" }}>
          <p
            style={{
              fontSize: "1.5em",
              fontWeight: "500",
              color: "#0F0718",
              flex: 1,
              textAlign: "center",
            }}
          >
            {additionalInfo.length > 0 ? "Coupon Additional Information" : "Coupon Code"}
          </p>
          <img
            src={Close}
            onClick={closeCouponModal}
            style={{
              marginLeft: "auto",
              paddingBottom: "4vh",
              paddingTop: "2vh",
              cursor: "pointer",
              width: "1.5vw",
            }}
          />
        </div>
      }
      open={couponModalVisible}
      className="filter"
      headerStyle={{ background: "#f3f4f9", borderBottom: "none", fontFamily: "Inter" }}
      styles={{ body: { background: "#f3f4f9", paddingBottom: 0, borderRadius: "0" } }}
      onClose={() => {
        setManualDiscountInput("");
        closeCouponModal();
        setAdditionalInfo([]);
        setSelectedCoupon(null);
        if (searchInputRef?.current) {
          searchInputRef?.current.focus();
        }
      }}
      //  id="sm-drawer-close"
      height="75vh"
    >
      <BarCodeComponentForExternalCoupon setCouponInput={setCouponInput} />
      {additionalInfo?.length > 0 ? (
        <Form form={additionalInfoForm} onFinish={couponInfo} layout="vertical">
          <Scrollbars style={{ height: "40vh" }}>
            <Row gutter={[16, 16]} style={{ margin: "0px 100px 0px 100px", padding: "0px" }}>
              {additionalInfo?.map((field) => (
                <Col key={field.fieldName} span={12}>
                  <p
                    style={{
                      // marginBottom: "10px",
                      // marginTop: "12px",
                      fontWeight: "500",
                      fontSize: "1.25em",
                      color: "#0F0718",
                    }}
                  >
                    <span>{field.mandatory === "Y" && <span style={{ color: "red", marginRight: 4, fontSize: "1em" }}>*</span>}</span>
                    {field.displayLabel}
                  </p>
                  <Form.Item
                    name={field.fieldName}
                    rules={field.mandatory === "Y" ? [{ required: true, message: `${field.displayLabel} is required` }] : []}
                    style={{ display: "flex" }}
                  >
                    {/* <div style={{ display: "flex", alignItems: "center", width: "100%" }}> */}
                    {field.fieldType === "DT" ? (
                      <DatePicker
                        style={{
                          flex: 1,
                          borderRadius: "4px",
                          height: "7.7vh",
                          marginRight: "8px",
                          border: "none",
                          width: "90%",
                        }}
                        format="DD-MM-YYYY"
                      />
                    ) : field.fieldType === "DTE" ? (
                      <DatePicker
                        showTime
                        style={{
                          flex: 1,
                          borderRadius: "4px",
                          height: "7.7vh",
                          marginRight: "8px",
                          border: "none",
                          width: "90%",
                        }}
                      />
                    ) : field.fieldType === "NU" ? (
                      <Input
                        type="number"
                        style={{
                          flex: 1,
                          borderRadius: "4px",
                          height: "7.7vh",
                          marginRight: "8px",
                          border: "none",
                          maxWidth: "90%",
                        }}
                      />
                    ) : field.fieldType === "LI" ? (
                      <Select
                        placeholder="Select Reason"
                        className="custom-select"
                        style={{
                          flex: 1,
                          borderRadius: "4px",
                          maxHeight: "7.7vh",
                          marginRight: "8px",
                          border: "none",
                          maxWidth: "90%",
                        }}
                      >
                        {field?.validationRule?.split(",").map((item) => (
                          <Select.Option key={item} value={item}>
                            {item}
                          </Select.Option>
                        ))}
                      </Select>
                    ) : (
                      <TextArea
                        style={{
                          flex: 1,
                          borderRadius: "4px",
                          height: "7.7vh",
                          marginRight: "8px",
                          border: "none",
                          maxWidth: "90%",
                        }}
                      />
                    )}
                    {/* </div> */}
                  </Form.Item>
                </Col>
              ))}
            </Row>
          </Scrollbars>
          <Row
            style={{
              marginTop: "5vh",
              padding: "0 1% 0 3.5%",
              fontSize: "1vw",
            }}
            gutter={[8, 8]}
          >
            <Col span={13}></Col>
            <Col span={10} style={{ textAlign: "right" }}>
              <Button className="discount-apply-btn" htmlType="submit" style={{ width: "40%" }}>
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      ) : (
        <Row>
          <Col span={2} />
          <Col span={9} style={{ paddingRight: "1vw" }}>
            <Row style={{ marginTop: "", fontSize: "1vw" }}>
              <Col span={24}>
                <Row gutter={[12, 12]}>
                  {externalCoupons?.map((coupon, mdi) => {
                    const isSelected = selectedCoupon?.id === coupon.id;

                    return (
                      <Col key={coupon.id} span={12}>
                        <div
                          style={{
                            backgroundColor: isSelected ? "#90909880" : "#fff",
                            color: isSelected ? "#fff" : "#0F0718",
                            padding: "0.5vh 0.5vw",
                            borderRadius: "4px",
                            height: "6.5vh",
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            transition: "all 0.2s ease-in-out",
                          }}
                          onClick={() => {
                            const selectedCoupon = externalCoupons[mdi];
                            const discountValue = selectedCoupon?.discountType === "V" ? (selectedCoupon?.amountDiscount ?? "") : (selectedCoupon?.percentageDiscount ?? "");
                            setSelectedCoupon(coupon);
                            setSelectedExternalCouponType(selectedCoupon.mPricingrulesId);
                            setManualDiscountInput(discountValue);

                            setTimeout(() => {
                              couponInputRef.current?.focus();
                            }, 100);
                          }}
                        >
                          <img src={Offer} style={{ height: "2.5vh", width: "1.5vw" }} alt="offer" />
                          <span
                            style={{
                              paddingLeft: "0.5vw",
                              fontSize: "1em",
                              fontWeight: 400,
                              color: "#0F0718",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {coupon.name}
                          </span>
                        </div>
                      </Col>
                    );
                  })}
                </Row>

                <p
                  style={{
                    marginBottom: "10px",
                    marginTop: "12px",
                    fontWeight: "500",
                    fontSize: "1.25em",
                    color: "#0F0718",
                  }}
                >
                  Coupon Code
                </p>
                <Input
                  onPressEnter={couponModalVisible && !selectedCoupon && !selectedExternalCouponType && !couponValidating ? checkCoupon : null}
                  onChange={(e) => setCouponInput(e.target.value)}
                  value={couponInput}
                  ref={couponInputRef}
                  onFocus={() => setIsInputFocused(true)}
                  style={{
                    marginTop: "1vh",
                    width: "100%",
                    borderRadius: "4px",
                    height: "7.7vh",
                  }}
                  size="large"
                  className="discount-value-input"
                  placeholder="Type Code"
                />
              </Col>
              <div style={{ marginTop: "4vh" }}>
                {selectedCoupon ? (
                  selectedCoupon?.type === "TD" ? (
                    <>
                      <p>
                        Discount - {tillData?.tillAccess?.csBunit?.currencies[0]?.currSymbol}{" "}
                        {totalBillDiscountData?.discountedAmount?.toFixed(tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2)}
                      </p>
                      <p>
                        After discount: {totalBillDiscountData?.finalAmount?.toFixed(tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2)}{" "}
                        {tillData?.tillAccess?.csBunit?.currencies[0]?.currSymbol}
                      </p>
                    </>
                  ) : (
                    <>
                      Discount - {tillData?.tillAccess?.csBunit?.currencies[0]?.currSymbol}{" "}
                      {cart.items.length > 0
                        ? selectedCoupon?.discountType === "P"
                          ? (cart.items.reduce((total, item) => total + item.realPrice * item.weight, 0) * (manualDiscountInput / 100)).toFixed(
                              tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2
                            )
                          : manualDiscountInput
                        : 0}
                    </>
                  )
                ) : null}
              </div>
            </Row>
            <Row gutter={[16, 16]} style={{ marginTop: "4vh", fontSize: "1vw" }}>
              {cart?.couponInput?.length > 0 && (
                <Col span={24}>
                  <p
                    style={{
                      color: "#0F0718",
                      marginBottom: "1vh",
                      fontSize: "1.15em",
                      fontWeight: "500",
                      marginBottom: "10px",
                    }}
                  >
                    Applied Coupons
                  </p>
                </Col>
              )}
              {cart?.couponInput?.map((coupon) => {
                return (
                  <Col span={12} style={{ padding: "0 0.6vw" }}>
                    <div
                      style={{
                        backgroundColor: "#fff",
                        padding: "0.5vh 0.5vw",
                        borderRadius: "4px",
                        height: "6.5vh",
                        display: "flex",
                        justifyContent: "",
                        alignItems: "center",
                        position: "relative",
                      }}
                    >
                      <img src={Offer} style={{ height: "2.5vh", width: "1.5vw" }} />
                      <span
                        style={{
                          paddingLeft: "0.5vw",
                          fontSize: "1em",
                          fontWeight: 400,
                          color: "#0F0718",
                        }}
                      >
                        {coupon.couponCode}
                      </span>
                      <img
                        src={Close}
                        onClick={() => removeCouponConfirmation(coupon)}
                        style={{
                          height: "3.5vh",
                          width: "1.5vw",
                          cursor: "pointer",
                          position: "absolute",
                          right: "0.8vw",
                        }}
                      />
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Col>

          <Col span={2} />
          <Col span={11} style={{ marginBottom: "3vh", fontSize: "1vw" }}>
            <Row gutter={[4, 4]} style={{ padding: "0 1% 0 3.5%" }}>
              <Col span={5}>
                <button className="amt-dial-btn-super-market" onClick={() => handleCouponInput("1")}>
                  1
                </button>
              </Col>
              <Col span={5}>
                <button className="amt-dial-btn-super-market" onClick={() => handleCouponInput("2")}>
                  2
                </button>
              </Col>
              <Col span={5}>
                <button className="amt-dial-btn-super-market" onClick={() => handleCouponInput("3")}>
                  3
                </button>
              </Col>
              <Col span={5}>
                <button
                  className="amt-dial-btn-super-market"
                  onClick={() => handleCouponInput("x")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={CancelArrow}
                    alt="back space"
                    width={width <= 1024 ? 20 : 25}
                    height={width <= 1024 ? 15 : 15}
                    style={{
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                </button>
              </Col>
              <Col span={4} />
              <Col span={5}>
                <button className="amt-dial-btn-super-market" onClick={() => handleCouponInput("4")}>
                  4
                </button>
              </Col>
              <Col span={5}>
                <button className="amt-dial-btn-super-market" onClick={() => handleCouponInput("5")}>
                  5
                </button>
              </Col>
              <Col span={5}>
                <button className="amt-dial-btn-super-market" onClick={() => handleCouponInput("6")}>
                  6
                </button>
              </Col>
              <Col span={5}>
                <button className="amt-dial-btn-super-market-cancel-discount" onClick={() => handleCouponInput("clear")}>
                  Clear
                </button>
              </Col>
              <Col span={4} />
              <Col span={15}>
                <Row gutter={[8, 6]}>
                  <Col span={8}>
                    <button className="amt-dial-btn-super-market" onClick={() => handleCouponInput("7")}>
                      7
                    </button>
                  </Col>
                  <Col span={8}>
                    <button className="amt-dial-btn-super-market" onClick={() => handleCouponInput("8")}>
                      8
                    </button>
                  </Col>
                  <Col span={8}>
                    <button className="amt-dial-btn-super-market" onClick={() => handleCouponInput("9")}>
                      9
                    </button>
                  </Col>
                  <Col span={8}>
                    <button className="amt-dial-btn-super-market" onClick={() => handleCouponInput("0")}>
                      0
                    </button>
                  </Col>
                  <Col span={8}>
                    <button className="amt-dial-btn-super-market" onClick={() => handleCouponInput("00")}>
                      00
                    </button>
                  </Col>
                  <Col span={8}>
                    <button className="amt-dial-btn-super-market">.</button>
                  </Col>
                </Row>
              </Col>
              <Col span={5}>
                <button
                  // id="sm-amount-buttonEnter"
                  className="amt-dial-btn-market-discount"
                  disabled={couponValidating}
                  onClick={() => {
                    checkCoupon();
                  }}
                >
                  Enter
                </button>
              </Col>
              <Col span={4} />
            </Row>
            <Row style={{ marginTop: "2vh", padding: "0 1% 0 3.5%" }} gutter={[8, 8]}>
              <Col span={10}>
                <Button
                  className="discount-remove-btn"
                  onClick={() => {
                    setManualDiscountInput("");
                    closeCouponModal();
                  }}
                >
                  Cancel
                </Button>
              </Col>
              <Col span={10}>
                <Button
                  className="discount-apply-btn"
                  loading={couponValidating}
                  disabled={couponValidating}
                  onClick={() => {
                    checkCoupon();
                  }}
                >
                  Apply
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </Drawer>
  );
};

export default CouponDrawer;
